export default {
    signIn: {
        title: "Welcome Back",
        subtitle: "Sign in to continue to Pitango Market",
        emailLabel: "Email",
        emailPlaceholder: "you@example.com",
        passwordLabel: "Password",
        passwordPlaceholder: "Your password",
        showPassword: "Show",
        hidePassword: "Hide",
        submit: "Sign In",
        submitting: "Signing in…",
        forgotPassword: "Forgot Password?",
        noAccount: "Don't have an account?",
        signUpLink: "Create One",
        validation: {
            emailRequired: "Email is required.",
            emailInvalid: "Enter a valid email address.",
            passwordRequired: "Password is required.",
            passwordLength: "Password must be at least {{min}} characters."
        },
        errors: {
            wrongCredentials: "Incorrect email or password.",
            emailNotVerified: "Please verify your email before signing in.",
            passwordResetRequired: "You need to reset your password before signing in.",
            generic: "Something went wrong. Please try again."
        },
        resend: {
            action: "Resend verification email",
            sent: "Verification email sent."
        }
    }
} as const;
